import { type HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export interface CardContentProps extends HTMLAttributes<HTMLDivElement> {}

export const CardContent = ({ className, ...props }: CardContentProps) => {
  return <div className={twMerge('space-y-2', className)} {...props} />
}

CardContent.displayName = 'CardContent'
